const blue = "#4664dc";
const red = "#c83636";
const plains = "#e6e6e6";
const mountain = "#bbbbbb";
const neutralCastle = "#707070";
const paperInk = "#fffdf4";

export type Owner = -1 | 0 | 1;
export type Tile = {
  owner: Owner;
  count: number;
  mountain: boolean;
  general: boolean;
  castle: boolean;
};

export type GeneralsBoardFrame = {
  readonly rows: number;
  readonly cols: number;
  readonly tiles: readonly Tile[];
};

// Replays store a complete first frame followed by [index, owner, army] triples.
export type GeneralsReplay = {
  readonly v: 1;
  readonly rows: number;
  readonly cols: number;
  readonly mountains: readonly number[];
  readonly cities: readonly (readonly [number, number])[];
  readonly generals: readonly number[];
  readonly first: {
    readonly o: readonly Owner[];
    readonly a: readonly number[];
  };
  readonly frames: readonly (readonly number[])[];
};

export function shade({
  hex,
  k,
}: {
  readonly hex: string;
  readonly k: number;
}): string {
  const n = Number.parseInt(hex.slice(1), 16);
  const ch = (shift: number) =>
    Math.round(((n >> shift) & 0xff) * k)
      .toString(16)
      .padStart(2, "0");
  return `#${ch(16)}${ch(8)}${ch(0)}`;
}

export function fillOf(t: Tile): {
  readonly fill: string;
  readonly ink: string;
} {
  if (t.mountain) return { fill: mountain, ink: "#222" };

  if (t.owner === -1) {
    return t.castle
      ? { fill: neutralCastle, ink: paperInk }
      : { fill: plains, ink: "#333" };
  }

  const own = t.owner === 0 ? blue : red;

  if (t.general) return { fill: shade({ hex: own, k: 0.65 }), ink: paperInk };

  if (t.castle) return { fill: shade({ hex: own, k: 0.8 }), ink: paperInk };

  return { fill: own, ink: paperInk };
}

export type GlyphKind = "mountain" | "general" | "castle";

export function glyphKindOf(t: Tile): GlyphKind | null {
  if (t.mountain) return "mountain";

  if (t.general) return "general";

  if (t.castle) return "castle";

  return null;
}

export function countLabelOf(t: Tile): string {
  if (t.mountain) return "";

  if (t.general || t.castle) return t.count > 0 ? String(t.count) : "";

  return t.owner !== -1 && t.count > 0 ? String(t.count) : "";
}
